import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\FeedbacksController::store
* @see app/Http/Controllers/Api/FeedbacksController.php:25
* @route '/api/feedbacks'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/feedbacks',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\FeedbacksController::store
* @see app/Http/Controllers/Api/FeedbacksController.php:25
* @route '/api/feedbacks'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\FeedbacksController::store
* @see app/Http/Controllers/Api/FeedbacksController.php:25
* @route '/api/feedbacks'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const feedbacks = {
    store: Object.assign(store, store),
}

export default feedbacks